import React from "react";
import { LogoutRoute } from "../../../context/AuthContext";
import RegisterLayoutHandler from "../../layouts/RegisterLayoutHandler";
import ReportLayoutHandler from "../../layouts/ReportLayoutHandler";
import {
  API_ACCOUNTS_ROLES_REGISTER,
  API_ALL_WALLET_TRANSACTIONS,
  API_MERCHANT_FEES_LIST,
  API_PAYMENT_ITEM_LIST,
  API_PAYMENT_SERVICE,
  API_PAYMENT_TYPES,
  API_WALLET_TRANSACTIONS,
} from "../../../utils/apis";
import WalletDepositRequest from "../wallet_transfer/WalletDepositRequest";
import WalletDepositConfirm from "../wallet_transfer/WalletDepositConfirm";
import { ADMIN } from "../../../utils/constants";
import FraudDashboard from "./FraudDashboard";
import ApiIntegration from "../api_integration/ApiIntegration";
import {
  URL_AGENT_COMMISSION_SUMMARY,
  // URL_MERCHANT_MONTHLY_REPORT,
  URL_MONTHLY_SUMMARY,
  URL_PARTNER_COMMISSION_SUMMARY,
  // URL_PAYMENT_ITEM_MONTHLY_REPORT,
  URL_PAYMENT_ITEM_CHANNEL_REPORT,
  URL_TRANSACTION_CHANNEL_SEPARATION,
  URL_TRANSACTION_SUMMARY,
  URL_USSD_INPUT_LOGS,
  URL_YOYA_COMMISSION_SUMMARY,
  URL_MERCHANT_SUMMARY,
  URL_PAYMENT_ITEM_SUMMARY,
  URL_INCIDENT_TICKET_CATEGORY_REPORT,
  URL_INCIDENT_TICKET_SEVERITY_REPORT,
} from "../../../utils/urls";
import USSDServicesPage from "../ussd_services/USSDServicesPage";
// import PaymentItemReport from "../reports/PaymentItemReport";
import { PartnerCommissionSummary } from "../reports/PartnerCommissionSummary";
import { AgentCommissionSummary } from "../reports/AgentCommissionSummary";
import { YoyaCommissionSummary } from "../reports/YoyaCommissionSummary";
import UtilityPaymentsRequest from "../utility_payments/UtilityPaymentsRequest";
import UtilityPaymentsConfirm from "../utility_payments/UtilityPaymentsConfirm";

const ApplicationDetailView = React.lazy(
  () => import("../../../hooks/loan_applications/ApplicationDetailView"),
);
const GenericViewer = React.lazy(() => import("../../layouts/GenericViewer"));
const InventoryDetailView = React.lazy(
  () => import("../../../hooks/inventory/InventoryDetailView"),
);

const AdhocReports = React.lazy(
  () => import("../../pages/reports/adhoc/AdhocReports"),
);
const CommissionsReport = React.lazy(
  () => import("../reports/CommissionsReport"),
);
const TransactionsReport = React.lazy(
  () => import("../../../hooks/system_reports/utility_logs/TransactionsReport"),
);
const WalletBalanceReport = React.lazy(
  () => import("../reports/WalletBalanceReport"),
);

const SettlementReport = React.lazy(
  () => import("../reports/SettlementReport"),
);

// const MerchantSummaryReport = React.lazy(
//   () => import("../reports/MerchantSummaryReport"),
// );

const SalesReport = React.lazy(() => import("../reports/SalesReport"));

const CommissionsRevenueReport = React.lazy(
  () => import("../reports/CommissionsRevenueReport"),
);

const CommissionsSummaryReport = React.lazy(
  () => import("../reports/CommissionsSummaryReport"),
);

const TransactionListReport = React.lazy(
  () => import("../reports/TransactionListReport"),
);

const SettingsPage = React.lazy(() => import("../settings/SettingsPage"));
const DashboardPage = React.lazy(() => import("./DashboardPage"));
const GenericForm = React.lazy(() => import("../../layouts/GenericForm"));
const GenericRegister = React.lazy(
  () => import("../../layouts/GenericRegister"),
);

const ChartsOfAccountsReport = React.lazy(
  () => import("../reports/ChartOfAccountsReports"),
);

const ChartsOfAccountsRegister = React.lazy(
  () => import("../reports/ChartOfAccountsRegister"),
);

const GeneralLedgerReport = React.lazy(
  () => import("../reports/legders/GeneralLedgerReport"),
);

const ProfitAndLossReport = React.lazy(
  () => import("../reports/legders/ProfitAndLossReport"),
);

const MerchantSubLedger = React.lazy(
  () => import("../reports/legders/MerchantSubLedger"),
);

const AgentSubLedgerReport = React.lazy(
  () => import("../reports/legders/AgentSubLedgerReport"),
);

const PublicUserSubLedgerReport = React.lazy(
  () => import("../reports/legders/PublicUserSubLedgerReport"),
);

const FinancialSubLedger = React.lazy(
  () => import("../reports/legders/FinancialSubLedger"),
);

const CustomerReportRequests = React.lazy(
  () =>
    import("../../../hooks/system_reports/utility_logs/CustomerReportRequests"),
);

const DailyBatchSettlementReport = React.lazy(
  () =>
    import(
      "../../../hooks/finance_and_treasury/settlement_engine/reports/DailyBatchSettlementReport"
    ),
);

const ComplianceReport = React.lazy(
  () =>
    import(
      "../../../hooks/finance_and_treasury/settlement_engine/reports/ComplianceReport"
    ),
);

//System Logs

const UtilityLogsReport = React.lazy(
  () => import("../../../hooks/system_reports/utility_logs/UtilityLogsReport"),
);
const ExternalCallLogsReport = React.lazy(
  () =>
    import("../../../hooks/system_reports/utility_logs/ExternalCallLogsReport"),
);

const SystemExceptionsReport = React.lazy(
  () =>
    import("../../../hooks/system_reports/utility_logs/SystemExceptionsReport"),
);

const TransactionsReportTable = React.lazy(
  () => import("../../../hooks/system_reports/utility_logs/TransactionsReport"),
);

const WalletTransferRequest = React.lazy(
  () => import("../wallet_transfer/WalletTransferRequest"),
);

const WalletTransferConfirm = React.lazy(
  () => import("../wallet_transfer/WalletTransferConfirm"),
);

const LiquidationLogs = React.lazy(
  () => import("../../../hooks/system_reports/utility_logs/LiquidationLogs"),
);

const TransactionsHistoryTable = React.lazy(
  () => import("../reports/TransactionsHistoryTable"),
);

const TransactionSummaryReport = React.lazy(
  () => import("../reports/TransactionSummaryReport"),
);

const profile = JSON.parse(localStorage.getItem("profile") || "{}");
const roleName = profile?.role?.name || null;

const DashboardRoutes = [
  {
    path: "/",
    component: <DashboardPage />,
    exact: true,
  },
  {
    path: "/fraud_dashboard",
    component: <FraudDashboard />,
    exact: true,
  },
  {
    path: "/register/charts_of_accounts_configurables",
    component: <ChartsOfAccountsRegister />,
    exact: true,
  },
  {
    path: "/register/:id",
    component: <GenericRegister />,
    exact: true,
  },
  {
    path: "/register/roles",
    component: (
      <RegisterLayoutHandler
        source_id={"roles"}
        api={`${API_ACCOUNTS_ROLES_REGISTER}`}
        rootData={true}
        showTotals={true}
      />
    ),
    exact: true,
  },
  {
    path: "/register/payment_items",
    component: (
      <RegisterLayoutHandler
        source_id={"payment_items"}
        api={`${API_PAYMENT_ITEM_LIST}`}
        rootData={true}
        showTotals={true}
      />
    ),
    exact: true,
  },
  {
    path: "/register/payment_types",
    component: (
      <RegisterLayoutHandler
        source_id={"payment_types"}
        api={`${API_PAYMENT_TYPES}`}
        rootData={true}
        showTotals={true}
      />
    ),
    exact: true,
  },
  {
    path: "/register/wallet_transfers",
    component: (
      <RegisterLayoutHandler
        source_id={"wallet_transfers"}
        api={
          roleName === ADMIN
            ? `${API_ALL_WALLET_TRANSACTIONS}`
            : `${API_WALLET_TRANSACTIONS}`
        }
        rootData={true}
        showTotals={true}
      />
    ),
    exact: true,
  },
  {
    path: "/register/partners",
    component: (
      <RegisterLayoutHandler
        source_id={"partners"}
        api={`transact/partners/`}
        rootData={true}
        showTotals={true}
      />
    ),
    exact: true,
  },
  {
    path: "/register/merchant_fees",
    component: (
      <RegisterLayoutHandler
        source_id={"merchant_fees"}
        api={`${API_MERCHANT_FEES_LIST}`}
        rootData={true}
        showTotals={true}
      />
    ),
    exact: true,
  },

  {
    path: "/register/payment_services",
    component: (
      <RegisterLayoutHandler
        source_id={"payment_services"}
        api={`${API_PAYMENT_SERVICE}`}
        rootData={true}
        showTotals={true}
      />
    ),
    exact: true,
  },
  {
    path: "/register/:id/:status",
    component: <GenericRegister />,
    exact: true,
  },
  {
    path: "/:source_id/create",
    component: <GenericForm />,
    exact: true,
  },
  {
    path: "/:source_id/create/:parent_id",
    component: <GenericForm />,
    exact: true,
  },
  {
    path: "/:source_id/drafts/:draft_id",
    component: <GenericForm />,
    exact: true,
  },

  {
    path: "/:source_id/update/:id",
    component: <GenericForm />,
    exact: true,
  },
  {
    path: "/loan_application/view/:id",
    component: <ApplicationDetailView />,
    exact: true,
  },
  {
    path: "/inventory/view/:id",
    component: <InventoryDetailView />,
    exact: true,
  },
  {
    path: "/:source_id/view/:id",
    component: <GenericViewer />,
    exact: true,
  },
  {
    path: "/:source_id/view/:id",
    component: <GenericViewer />,
    exact: true,
  },

  {
    path: "/settings",
    component: <SettingsPage />,
    exact: true,
  },

  {
    path: "/wallet-transfer/create",
    component: <WalletTransferRequest />,
    exact: true,
  },
  {
    path: "/api-integration/create",
    component: <ApiIntegration />,
    exact: true,
  },
  {
    path: "/wallet-deposit/create",
    component: <WalletDepositRequest />,
    exact: true,
  },
  {
    path: "/wallet-transfer/confirm",
    component: <WalletTransferConfirm />,
    exact: true,
  },
  {
    path: "/wallet-deposit/confirm",
    component: <WalletDepositConfirm />,
    exact: true,
  },
  {
    path: "/utility-payments/create",
    component: <UtilityPaymentsRequest />,
    exact: true,
  },
  {
    path: "/utility-payments/confirm",
    component: <UtilityPaymentsConfirm />,
    exact: true,
  },

  {
    path: "/reports/customer-report-requests",
    component: <CustomerReportRequests />,
    exact: true,
  },

  //USSD Services

  {
    path: URL_USSD_INPUT_LOGS,
    component: <USSDServicesPage />,
    exact: true,
  },
  // Reports
  {
    path: `/reports/adhoc`,
    component: <AdhocReports />,
    exact: true,
  },
  {
    path: `/reports/transactions`,
    component: <TransactionsReport />,
    exact: true,
  },
  // Transactions History
  {
    path: `/transactions/:chart_id`,
    component: <TransactionsHistoryTable />,
    exact: true,
  },
  {
    path: `/reports/commissions`,
    component: <CommissionsReport />,
    exact: true,
  },
  {
    path: `/reports/wallet-balance-report`,
    component: <WalletBalanceReport />,
    exact: true,
  },

  {
    path: `/reports/settlement-report`,
    component: <SettlementReport />,
    exact: true,
  },

  {
    path: `/reports/sales-report`,
    component: <SalesReport />,
    exact: true,
  },
  {
    path: `/reports/commission-revenue-report`,
    component: <CommissionsRevenueReport />,
    exact: true,
  },
  {
    path: `/reports/commission-summary-report`,
    component: <CommissionsSummaryReport />,
    exact: true,
  },
  {
    path: `/reports/daily-batch-settlement-report`,
    component: <DailyBatchSettlementReport />,
    exact: true,
  },
  {
    path: `/reports/compliance-report`,
    component: <ComplianceReport />,
    exact: true,
  },
  {
    path: URL_MONTHLY_SUMMARY,
    component: <TransactionSummaryReport />,
    exact: true,
  },
  {
    path: URL_TRANSACTION_SUMMARY,
    component: <ReportLayoutHandler source_id="transaction_summary" />,
    exact: true,
  },
  {
    path: URL_TRANSACTION_CHANNEL_SEPARATION,
    component: (
      <ReportLayoutHandler source_id="transaction_channel_separation" />
    ),
    exact: true,
  },
  {
    // path: URL_MERCHANT_MONTHLY_REPORT,
    path: URL_MERCHANT_SUMMARY,
    component: <ReportLayoutHandler source_id="merchant_summary" />,
    // component: <MerchantSummaryReport />,
    exact: true,
  },

  {
    // path: URL_PAYMENT_ITEM_MONTHLY_REPORT,
    path: URL_PAYMENT_ITEM_SUMMARY,
    // component: <PaymentItemReport />,
    component: <ReportLayoutHandler source_id="payment_item_summary" />,
    exact: true,
  },
  {
    path: URL_PARTNER_COMMISSION_SUMMARY,
    component: <PartnerCommissionSummary />,
    exact: true,
  },
  {
    path: URL_AGENT_COMMISSION_SUMMARY,
    component: <AgentCommissionSummary />,
    exact: true,
  },
  {
    path: URL_YOYA_COMMISSION_SUMMARY,
    component: <YoyaCommissionSummary />,
    exact: true,
  },
  {
    path: URL_PAYMENT_ITEM_CHANNEL_REPORT,
    component: <ReportLayoutHandler source_id="payment_item_channel_report" />,
    exact: true,
  },
  {
    path: URL_INCIDENT_TICKET_CATEGORY_REPORT,
    component: (
      <ReportLayoutHandler source_id="incident_ticket_category_report" />
    ),
    exact: true,
  },
  {
    path: URL_INCIDENT_TICKET_SEVERITY_REPORT,
    component: (
      <ReportLayoutHandler source_id="incident_ticket_severity_report" />
    ),
    exact: true,
  },
  {
    path: `/reports/transaction-list-report`,
    component: <TransactionListReport />,
    exact: true,
  },

  {
    path: `/reports/chart-of-accounts-report`,
    component: <ChartsOfAccountsReport />,
    exact: true,
  },

  {
    path: `/reports/general-ledger-report`,
    component: <GeneralLedgerReport />,
    exact: true,
  },
  {
    path: `/reports/profit-and-loss-report`,
    component: <ProfitAndLossReport />,
    exact: true,
  },
  {
    path: `/reports/merchant-sub-ledgers`,
    component: <MerchantSubLedger />,
    exact: true,
  },
  {
    path: `/reports/agent-sub-ledgers`,
    component: <AgentSubLedgerReport />,
    exact: true,
  },
  {
    path: `/reports/public-user-sub-ledgers`,
    component: <PublicUserSubLedgerReport />,
    exact: true,
  },
  {
    path: `/reports/financial-sub-ledgers`,
    component: <FinancialSubLedger />,
    exact: true,
  },

  {
    path: `/reports/utility-logs-report`,
    component: <UtilityLogsReport />,
    exact: true,
  },

  {
    path: `/reports/system-exceptions-report`,
    component: <SystemExceptionsReport />,
    exact: true,
  },
  {
    path: `/reports/liquidation-logs`,
    component: <LiquidationLogs />,
    exact: true,
  },

  {
    path: `/reports/external-call-logs-report`,
    component: <ExternalCallLogsReport />,
    exact: true,
  },
  {
    path: `/reports/transactions-report`,
    component: <TransactionsReportTable />,
    exact: true,
  },
  {
    path: `/reports/external-call-logs-report`,
    component: <ExternalCallLogsReport />,
    exact: true,
  },

  // Logout
  {
    path: "/logout",
    component: <LogoutRoute />,
    exact: true,
  },
];

export default DashboardRoutes;
